<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <ContentArea>
      <v-flex pa-3>
        <div v-html="status"/>
      </v-flex>
    </ContentArea>
    <Footer/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import ContentArea from '../components/ContentArea'
import language from '@/assets/javascript/language'
import axios from 'axios'

export default {
  name: 'Dashboard',
  data () {
    return {
      preferencesDialog: false,
      languages: [ 'en', 'da' ],
      status: '<td colspan="3">Loading status content...</td>'
    }
  },
  components: { Header, Sidebar, Footer, ContentArea },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'dashboard' })
    this.loadContent()
  },
  methods: {
    changeLocale (lang) {
      language.setLanguage(lang)
    },
    loadContent () {
      axios.get('/static/status.html')
        .then(response => {
          this.status = response.data
        })
    }
  }
}
</script>

<style>
  h3 {
    margin-bottom: 15px;
  }
  table.dashboardContent {
    width: 100%;
    border-collapse: collapse;
  }
  table.dashboardContent tr th {
    border-bottom: 1px solid darkgray;
    text-align: left;
    padding: 0 0 0 10px;
  }
  table.dashboardContent tr td {
    vertical-align: top;
    padding: 5px 20px 10px 8px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue